import React from "react";
import { View, Text } from "react-native";
import theme from "app/Theme/Theme";

const outerWidth = 30;

const RadioButton = ({ label, isSelected }) => {
  return (
    <View style={styles.main}>
      <View
        style={
          isSelected
            ? styles.outerCircle
            : {
                ...styles.outerCircle,
                borderColor: theme.colors["neutral.400"],
              }
        }
      >
        {isSelected && <View style={styles.innerCircle} />}
      </View>
      <Text
        style={
          isSelected
            ? styles.label
            : { ...styles.label, color: theme.colors["neutral.400"] }
        }
      >
        {label}
      </Text>
    </View>
  );
};

const styles = {
  main: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    marginLeft: 10,
  },
  outerCircle: {
    alignItems: "center",
    justifyContent: "center",
    width: outerWidth,
    height: outerWidth,
    borderRadius: outerWidth / 2,
    borderColor: theme.colors["brand.500"],
    borderWidth: 1,
  },
  innerCircle: {
    width: outerWidth / 2,
    height: outerWidth / 2,
    borderRadius: outerWidth / 4,
    backgroundColor: theme.colors["brand.500"],
  },
  label: {
    marginLeft: 5,
    fontSize: 12,
    color: theme.colors["brand.500"],
  },
};

export { RadioButton };
